export default __webpack_public_path__ + "static/media/sigh-no-more.89d06294.jpg";